// Template for the Dropdown
const assigneeAdminDropdownTemplate = `
  <div uib-dropdown class="filters-action">
    <style>
    .multi-select-dropdown .dropdown-toggle,
    .multi-select-dropdown .dropdown-toggle:active,  
    .multi-select-dropdown .dropdown-toggle:hover,
    .multi-select-dropdown .dropdown-button.dropdown-toggle:focus {
      border: none;
    }
    .dropdown-button{
      color: #242633;
      padding: 6px 10px 6px 10px;
      width: 100%;
      font-size: 14px;
      font-weight: inherit;
      letter-spacing: normal;
      text-transform: unset;
      border-color: transparent;
      margin: 0;
      text-align: left;
    }
    .dropdown-button:hover, .dropdown-button:focus, .dropdown-button:active {
      background-color: transparent;
      color: #242633;
    }
    </style>
    <button uib-dropdown-toggle id="{{data.buttonId}}" class="btn" type="button" id="menu1"data-tooltip-check="Assign Admin" >									
     <svg version="1.1" width="20" height="20" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 614.9 540" style="enable-background:new 0 0 614.9 540;" xml:space="preserve">
        <style type="text/css">
          .st0{fill:#9D9D9D;}          
        </style>
        <g>
          <path class="st0" d="M237.5,258.4c35,0,65.3-12.6,90.1-37.3C352.4,196.3,365,166,365,131c0-35-12.6-65.3-37.3-90.1
            c-24.8-24.8-55.1-37.3-90.1-37.3c-35,0-65.3,12.6-90.1,37.3S110,95.9,110,131c0,35,12.6,65.3,37.3,90.1
            C172.2,245.9,202.5,258.4,237.5,258.4z"/>
          <g>
            <path class="st0" d="M357.4,524.6l-0.2-1.7l-1.4,1c-16,12-40.8,10.9-56.6-2.5c-7.2-6.1-13.9-12.8-20-20
              c-13.4-15.8-14.5-40.7-2.5-56.6c0.4-0.5,0.7-0.9,1-1.4l-1.7-0.2c-19.6-2.8-35.9-18.8-37.8-37.2c-0.7-6.2-1-12.5-1-18.8
              c0-6.4,0.3-12.7,1-18.9c2-18.3,18.2-34.3,37.8-37l1.7-0.2l-1-1.4c-6.2-8.3-9-19.5-8-30.5c-9.2,2.4-18.6,3.7-27.8,3.7
              c-11.3,0-22.8-1.9-34.2-5.5c-11.6-3.7-21-7.9-27.9-12.3c-8-5.1-15.3-9.8-21.6-13.9c-10.1-6.6-15.3-8.8-20.7-8.8
              c-13.8,0-26.6,2.3-38.2,6.9c-11.6,4.6-21.7,10.9-29.9,18.8c-7.9,7.5-14.9,16.7-20.8,27.2c-5.7,10.1-10.4,20.7-13.8,31.4
              c-3.3,10.3-6.1,21.7-8.2,33.6c-2.1,11.9-3.6,23.1-4.3,33.5c-0.7,10.1-1.1,20.6-1.1,31.3c0,27.6,8.8,50,26.1,66.5
              c17.1,16.3,39.7,24.5,67.3,24.5h247.2C359.1,532.2,358,528.4,357.4,524.6z"/>
          </g>
          <path class="st0" d="M593.9,364.3c-1-9.1-10.5-17.5-20.2-18.9l-17.5-2.5c-2-6.1-4.5-12.1-7.4-17.8c0,0,4.8-6.4,10.6-14.2
            c5.9-7.8,5.7-22.1-1.7-30.8c-5.4-6.3-11.3-12.2-17.7-17.6c-8.7-7.4-23-7.6-30.8-1.7l-14.2,10.6c-5.7-2.9-11.6-5.4-17.8-7.4
            c0,0-1.1-7.9-2.5-17.5c-1.4-9.7-9.8-19.2-18.9-20.2c-5.5-0.6-11-0.9-16.6-0.9c-5.6,0-11.1,0.3-16.6,0.9c-9.1,1-17.5,10.5-18.9,20.2
            l-2,14l-0.5,3.6c-6.2,2-12.1,4.5-17.9,7.4c0,0-6.3-4.8-14.2-10.6c-1.8-1.3-3.9-2.3-6.1-3c-7.8-2.4-17.9-1-24.7,4.8
            c-6.3,5.4-12.3,11.3-17.7,17.6c-1.2,1.4-2.1,2.9-2.9,4.4c-4.4,8.6-3.8,19.8,1.2,26.4l10.6,14.2c-2.9,5.7-5.4,11.7-7.4,17.8
            c0,0-7.9,1.1-17.5,2.5c-9.7,1.4-19.2,9.8-20.2,18.9c-0.6,5.5-0.9,11-0.9,16.6c0,5.6,0.3,11.2,0.9,16.6c1,9.1,10.5,17.5,20.2,18.9
            l17.5,2.5c2,6.2,4.5,12.1,7.4,17.8c0,0-4.8,6.3-10.6,14.2c-5.9,7.8-5.7,22.1,1.7,30.8c5.4,6.3,11.3,12.2,17.7,17.7
            c8.7,7.4,23,7.6,30.8,1.7l14.2-10.6c5.7,2.9,11.7,5.4,17.9,7.4c0,0,1.1,7.9,2.5,17.5c0.7,4.8,3.1,9.5,6.4,13.2
            c3.4,3.8,7.9,6.5,12.5,7c5.4,0.6,11,0.9,16.6,0.9c5.6,0,11.1-0.3,16.6-0.9c9.1-1,17.5-10.5,18.9-20.2l2.5-17.5
            c6.2-2,12.1-4.5,17.8-7.4c0,0,6.3,4.8,14.2,10.6c7.8,5.9,22.1,5.7,30.8-1.7c6.3-5.4,12.3-11.3,17.7-17.7c7.4-8.7,7.6-23,1.7-30.8
            l-10.6-14.2c2.9-5.7,5.4-11.7,7.4-17.8c0,0,7.9-1.1,17.5-2.5c9.7-1.4,19.2-9.8,20.2-18.9c0.6-5.4,0.9-11,0.9-16.6
            C594.8,375.3,594.5,369.8,593.9,364.3z M487.4,430.7c-12.5,12.1-29.4,19.5-48.1,19.5c-38.2,0-69.2-31-69.2-69.2s31-69.2,69.2-69.2
            c8.7,0,17.1,1.6,24.7,4.6c26,10,44.5,35.2,44.5,64.7C508.5,400.5,500.4,418.1,487.4,430.7z"/>
        </g>										   
    </svg>
      

</button>
<ul uib-dropdown-menu id="assigneeAdminList" class="savedfilterlist assigneAdminDropDownC" ng-click="assignedadminEvent()">
  <li>
      <div class="assigneadmin has-search">
          <input type="text" id="filter-assigneAdmin" class="form-control" placeholder="Search" data-ng-keyup="filterAssigneAdmin()">
      </div>
  </li>
    
    <ul class="savedfilterlist fixedAssigneAdmin">
      <li role="presentation" id={{assigneeAdmin.user_ID}} class="dropdownfilter"  ng-repeat="assigneeAdmin in data.updatedfuncList">									
            <a  role="menuitem" tabindex="-1" ng-click="selectedAdmin(assigneeAdmin)"											
            >{{assigneeAdmin.email}}
            </a>
      </li>
      <label ng-if="data.updatedfuncList.length==0">No record found!</label>
    </ul>
  
  <li role="presentation" class="divider"></li>	
  <li>
    <center>
      <button class="btn btn-info" ng-disabled=" (selectedassigneeAdmin) ?  false : true"ng-click="data.function(selectedassigneeAdmin)">Assign</button>
      <button class="btn btn-default" ng-click="cancelAssigneAdminModal()">Cancel</button>
  </center>
  </li>										
</ul>
  `

// Controller for the dropdown directive
const assigneeAdminDropdownController = (
  $scope,
  $timeout,
  locationsService
) => {
  const stopEventExecution = event => {
    event.stopPropagation()
  }

  $('#assigneeAdminList').click(stopEventExecution)
  $scope.filterAssigneAdmin = () => {
    let txtvalue = document.getElementById('filter-assigneAdmin').value
    $scope.data.updatedfuncList = $scope.data.funcList.filter(x =>
      x.email.contains(txtvalue)
    )
    $scope.$apply()
  }

  $scope.assignedadminEvent = () => {
    event.stopPropagation()
  }
  $scope.selectedAdmin = selectedvalue => {
    var elems = document.querySelectorAll('.clickedSelected')
    ;[].forEach.call(elems, function(el) {
      el.classList.remove('clickedSelected')
    })
    let selectedAdminValue = document.getElementById(selectedvalue.user_ID)
      .firstElementChild
    selectedAdminValue.classList.add('clickedSelected')
    $scope.selectedassigneeAdmin = selectedvalue
    // $scope.$apply();
  }
  $scope.cancelAssigneAdminModal = () => {
    var elems = document.querySelectorAll('.clickedSelected')
    ;[].forEach.call(elems, function(el) {
      el.classList.remove('clickedSelected')
    })
    $scope.gridOptions.api.deselectAll()
    $('#assigneeAdminList').hide()
  }

  // Resets the selection of all
}

// returns DDO for the dropdown
const assigneeAdminDropdown = () => {
  return {
    restrict: 'AE',
    scope: {
      data: '=',
      gridOptions: '=',
    },
    replace: true,
    template: assigneeAdminDropdownTemplate,
    controller: assigneeAdminDropdownController,
  }
}

angular
  .module('app.directives')
  .directive('assigneeAdminDropdown', assigneeAdminDropdown)



// WEBPACK FOOTER //
// ./scripts/shared/directives/assignee-admin-dropdown.js